import React from 'react';
import EventsPortal from '../portal/EventsPortal';
import { FEAST_PORTAL } from '../portal/portalConfigs';

const Feast = () => <EventsPortal config={FEAST_PORTAL} />;

export default Feast;
